import { FC } from 'react';
import styles from './ReviewsList.module.scss';
import ReviewCard from '../review-card/ReviewCard';
import { IReviews, IReviewsData } from '@/interfaces/reviews.interface';

interface IReviewsList {
  reviews: IReviews;
  isReviewsPage?: boolean;
}

const ReviewsList: FC<IReviewsList> = ({ reviews, isReviewsPage }) => {
  const reviewsData = !isReviewsPage ? reviews.data.slice(0, 4) : reviews.data;

  return (
    <div className={`${styles.reviewsList}`}>
      {reviewsData.map((review: IReviewsData) => (
        <ReviewCard key={review.id} name={review.name} message={review.message} date={review.created_at} />
      ))}
    </div>
  );
};

export default ReviewsList;
